import { render, staticRenderFns } from "./instBoxItem.vue?vue&type=template&id=9e369620&scoped=true"
import script from "./instBoxItem.vue?vue&type=script&lang=js"
export * from "./instBoxItem.vue?vue&type=script&lang=js"
import style0 from "./instBoxItem.vue?vue&type=style&index=0&id=9e369620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e369620",
  null
  
)

export default component.exports